import { createAction, props } from '@ngrx/store';

import { BackendResponse, Company } from 'src/app/core/interfaces/shared.interface';
import { CompaniesParams } from '../companies.interface';

export const setCompanies = createAction(
  '[Companies Component] Set Companies',
  props<{ companies: BackendResponse<Company>; params: CompaniesParams; pageNumber: number }>()
);

// Requests
export const loadCompanies = createAction('[Request/Api Companies] Load Companies', (params: CompaniesParams, pageNumber: number = 1) => ({
  params,
  pageNumber
}));
